// extracted by mini-css-extract-plugin
export var overlay = "ShareModalOverlay-module--overlay--Jzu6w";
export var shareModalContainer = "ShareModalOverlay-module--shareModalContainer--NLl-c";